import React from 'react';
import cn from 'classnames';

import { Icons } from 'widget/components';
import { useIsPrimaryDark } from 'widget/hooks';
import { useWidgetContext } from 'widget/widget-context';

interface Trigger {
  isCallbackActive: boolean;
  isChatActive: boolean;
}

const Trigger = ({ isCallbackActive, isChatActive }: Trigger) => {
  const { isWidgetActive, setIsWidgetActive, widget } = useWidgetContext();
  const isPrimaryDark = useIsPrimaryDark();

  const isHidden = isCallbackActive && widget.type != 'horizontal';

  const isPulse =
    !isCallbackActive && !isChatActive && !isWidgetActive && widget.is_pulse;

  return (
    <>
      <button
        className={cn('whatcrm-widget-trigger', {
          'whatcrm-widget-trigger_hidden': isHidden,
          'whatcrm-widget-trigger_pulse': isPulse,
        })}
        onClick={() => setIsWidgetActive(prevValue => !prevValue)}
        type="button"
      >
        {isWidgetActive ? (
          <Icons.CloseCross fill={isPrimaryDark ? 'white' : 'dark'} />
        ) : (
          <svg
            className="whatcrm-widget-trigger__icon"
            style={{ fill: isPrimaryDark ? '#fff' : '#1f1f1f' }}
          >
            <use href={`#${widget.icon}`} />
          </svg>
        )}
      </button>
    </>
  );
};

export default Trigger;
